import { optionField, booleanField } from '@/common/utils/form/fieldTypes';

export const mga_inventory_depletion_method = 'mga_inventory_depletion_method';
export const mga_disable_warnings_on_reviewed_period = 'mga_disable_warnings_on_reviewed_period';

export type MGAInventoryDepletionMethod =
  | {
      label: string;
      value: string;
    }
  | string
  | null;

export type MGASettingsType = {
  [mga_inventory_depletion_method]: MGAInventoryDepletionMethod;
  [mga_disable_warnings_on_reviewed_period]: boolean;
};

const config = {
  [mga_inventory_depletion_method]: optionField(),
  [mga_disable_warnings_on_reviewed_period]: booleanField()
};

export default config;
